import { ArrowBack, ArrowForward, FilterList } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  InputLabel,
  Snackbar,
  styled,
  TextField,
  useMediaQuery,
  useTheme
} from "@mui/material";
import React, { useState, useEffect } from "react";
import TableComponent from "../TableComponent";

import MuiAlert from "@mui/material/Alert";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


// const rows = [

//   {
//     id: "343s",
//     firstName: "Harry",
//     lastName: "Migure",
//     email: "harry@gmail.com",
//     cart: "4",
//     mobile: "912308122",
//   },
//   {
//     id: "234",
//     firstName: "Shawn",
//     lastName: "Mendes",
//     email: "shawn@gmail.com",
//     cart: "2",
//     mobile: "13123123",
//   },
//   {
//     id: "21",
//     firstName: "Will",
//     lastName: "Smith",
//     email: "will@gmail.com",
//     cart: "3",
//     mobile: "12431212332",
//   },
//   {
//     id: "15",
//     firstName: "Sara",
//     lastName: "Whilmer",
//     email: "sara@gmail.com",
//     cart: "2",
//     mobile: "23213321",
//   },
// ];
const FilterBox = styled(Box)(({ theme }) => ({
  display: "flex",
  "& .MuiAutocomplete-inputRoot": {
    borderRadius: "4px 0px 0px 4px !important",
    padding: "6px 10px !important",
  },
  "& button": {
    borderRadius: "0px 4px 4px 0px !important",
    padding: "6px 10px !important",
  },
}));


const ResumeCustomer = ({
  step,
  setStep,
  // rows,
  //columns,
  //rows1,
  columns2,
  handleResume,
  handleDelete,
  customerDetails,
  setCustomerDetails,
  setKeyLoading,
  keyLoading,
  deletingRow,
  setDeletingRow,

}) => {


  const [snackStatus, setSnackStatus] = useState("");
  const [snackMessage, setSnackMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(false);
  //const [rows1, setRows1] = useState([]);
  //console.log("step", step);


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };



  const handleNew = () => {
    setStep(step + 1);
  };
  const rows = localStorage.getItem("order-list");
  const rows1 = JSON.parse(rows);
  //console.log("rows", rows)

  // useEffect(() => {
  //   const rows = localStorage.getItem("order-list");
  //   if (rows != null) {
  //     setRows1(JSON.parse(rows));
  //   }
  // }, [window.location.href]);
  

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchFilter = (value) => {
    //console.log("value", value)
    setSearch(value !== null ? `${value.clientName}` : "");
    //setCustomerID(value !== null ? `${value.customerID}` : "");
  };


  const handleFilter = () => {
    if (search) {
      const [clientName] = search.split(" ");
      setCustomerDetails({
        ...customerDetails,
        clientName

      });
    }
    setFilter(true);
  };
  // const MIN_INPUT_LENGTH = 1;

  // const exactMatches = rows1.filter((option) => {
  //   const clientNameLower = option.clientName.toLowerCase();
  //   const searchLower = search.toLowerCase();

  //   return (
  //     clientNameLower.includes(searchLower) &&
  //     clientNameLower.indexOf(searchLower) === 0 &&
  //     search.length >= MIN_INPUT_LENGTH
  //   );
  // });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const uniqueClientNames = [...new Set(rows1.map((row) => row.clientName))];

  const options = uniqueClientNames.map((clientName) => {
    const row = rows1.find((r) => r.clientName === clientName);
    return { id: row.id, clientName: row.clientName };
  });

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={12} xs={12}>
          <Box>
            <h1>Saved Orders</h1>
          </Box>
        </Grid>

        <Grid
          item
          md={8}
          xs={12}
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >

          <FilterBox>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              inputValue={search}
              options={options}
              getOptionLabel={(option) =>  option.clientName || null}
              renderOption={(props, option, index) => {return <li {...props} key={option.id}>{option.clientName}</li>}}
              //options={exactMatches}
              //getOptionLabel={(option) => option.clientName}
              sx={{ width: isMobile ? 260 : 500 }}
              onChange={(event, newValue) => {
                handleSearchFilter(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  value={search || ""}
                  onChange={handleChange}
                />
              )}
            />

            <Button
              color="primary"
              variant="contained"
              onClick={handleFilter}
            >
              Filter{" "}
              <FilterList fontSize="small" style={{ marginLeft: "5px" }} />
            </Button>
          </FilterBox>
        </Grid>


        <Grid item xs={12}>
          <TableComponent
            columns={columns2}
            rows={rows1}
            handleResume={handleResume}
            handleDelete={handleDelete}
            setKeyLoading={setKeyLoading}
            keyLoading={keyLoading}
            deletingRow={deletingRow}
            setDeletingRow={setDeletingRow}
            filter={filter}
            search={search}

          />
        </Grid>

        <Grid item xs={12}>
          <Box mt={3}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() =>
                setCustomerDetails({ ...customerDetails, type: "" })
              }
              style={{ marginRight: "10px" }}
              size="large"
            >
              <ArrowBack fontSize="small" sx={{ marginRight: "5px" }} /> Back
            </Button>
            {customerDetails.type === "new" &&
              <Button variant="contained" color="primary" onClick={() => setStep(step + 1)} size="large">
                Next <ArrowForward fontSize="small" sx={{ marginRight: "5px" }} />
              </Button>
            }
          </Box>
        </Grid>
      </Grid>



      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackStatus}
          sx={{ width: "100%" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ResumeCustomer;
